import React from 'react'
import "../Styles/Home.css";

function Typemsg() {
  return (
          <div className='contact_us'>
        <h1>Get exclusive travel tips and deals in your inbox</h1>
        <div class="message-box">
          <textarea placeholder="Type your message"></textarea>
          <button class="send-btn">
            Send Message <span>➜</span>
          </button>
        </div>

      </div>
  )
}

export default Typemsg